<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
    <path
      d="M20.206 22.721l-7.964-7.964-7.963 7.964a1.779 1.779 0 1 1-2.516-2.516l7.964-7.964-7.964-7.962a1.779 1.779 0 0 1 2.516-2.516l7.964 7.964 7.964-7.964a1.779 1.779 0 1 1 2.516 2.516l-7.964 7.964 7.964 7.964a1.779 1.779 0 0 1-2.516 2.516z"
      transform="translate(-1.243 -1.243)"
    />
  </svg>
</template>
